import instance from "../../helpers/AxiosInterceptor";

export const loadEncheres = (filters = {}) => {
  const params = Object.entries(filters).reduce((result, [key, value]) => {
    if (value !== "" && value !== null && value !== undefined) result[key] = value;
    return result;
  }, {});
  return instance.get("/encheres", { params });
};

export const saveEnchere = (request) => {
  return instance.post("/encheres", JSON.stringify(request));
};

export const deleteEnchere = (id) => {
  return instance.delete(`/encheres/${id}`);
};

export const loadExpiredEncheres = () => {
  return instance.get("/encheres/expired");
};

export const loadVisibleEncheres = (ferrailleurId) => {
  const query = ferrailleurId ? `?ferrailleurId=${ferrailleurId}` : "";
  return instance.get(`/encheres/visibles${query}`);
};

export const loadMesAchats = (ferrailleurId) => {
  const query = ferrailleurId ? `?ferrailleurId=${ferrailleurId}` : "";
  return instance.get(`/encheres/achats${query}`);
};
